import React, { useState } from 'react'
import { useSelector } from 'react-redux';
// import Button from '@mui/material/Button';
import leftarrow from "../../assets/Image/leftarrow.png"
import { useHistory } from "react-router";
import { useParams } from "react-router";
// import { getEntriesExport } from '../Services/ApiHandler';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { CSVLink } from "react-csv";

import "../../myfin_v2/css/bookclosure.css";
import { Button } from "../../myfin_v2/elements/Button";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
// import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close_grey.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";



const AdjustmentsNav = ({
    setFilterShow,
    csvLink,
    searchValue,
    setSearchValue
}) => {
    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const workspace_data = useSelector((state) => state.WSReducer);
    const { projectData } = useSelector((state) => state.ADJStandaloneReducer);

    const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
    const standaloneName = projectData?.project_name || "Standalone";

    const breadcrumbItems = [
        {
            label: workspaceName,
            link: `/adjustments`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: standaloneName,
            link: `/adjustments`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Adjustments",
            link: `/adjustments`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "Adjustment Log", link: "", className: "headerLable" },
    ];
    return (
        <>
            <div className="fscp-header" style={{ padding: "15px 0px" }}>
                <Breadcrumb style="margin-right:auto"
                    addCls={"bgClr1"}
                    items={breadcrumbItems}
                    headerActions={<></>}
                />
                {isSearchVisible ? (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#f4faf5',
                            border: '1px solid #c2e6d1 ',
                            borderRadius: '10px',
                            padding: '0 8px',
                            marginRight: '16px',
                            height: '36px',
                            animation: 'fadeIn 0.3s ease-in-out'
                        }}
                    >
                        <SearchIcon width={16} height={16} style={{ pointerEvents: 'none', marginRight: '6px' }} />
                        <input
                            type="text"
                            autoFocus
                            placeholder="Enter text for searching.."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            style={{ background: 'transparent', border: 'none', outline: 'none', padding: '0', fontSize: '14px', width: '220px' }}
                        />
                        <CloseIcon
                            width={12}
                            height={12}
                            style={{ cursor: 'pointer', marginLeft: '6px' }}
                            onClick={() => {
                                setIsSearchVisible(false);
                                setSearchValue("");
                            }}
                        />
                    </div>
                ) : (
                    <SearchIcon
                        width={20}
                        height={20}
                        className={`mr-3 ${commoncss.clickable}`}
                        onClick={() => setIsSearchVisible(true)}
                    />
                )}
                <FilterIcon width={20} height={20} className={`mr-2 ${commoncss.clickable}`} onClick={()=>{setFilterShow(true)}} />
                <CSVLink {...csvLink}>
                    <Button
                        icon={<ExportIcon width={18} height={18} />}
                        btnColor={buttoncss.secondary}
                        class_={buttoncss.greyBg}
                        label={"Export"}
                    />
                </CSVLink>

            </div>
        </>
    )
}

export default AdjustmentsNav